define('core/utils/url/parseQueryString',[
    'core/utils/collection/each',
], function (
    each
) {
    'use strict';

    /**
     * Create an object from the key-value pairs in a query string.
     * Duplicate keys are not supported (only last value will be used).
     *
     * @param {string} [queryString] - The search portion of a url. Must start with a ?.
     *                                 Defaults to window.location.search.
     * @returns {Object<string>} - The mapping of query string keys to values.
     */
    return function parseQueryString(queryString) {
        if (typeof queryString === 'undefined')
            queryString = window.location.search;

        var params = {};

        each(queryString.substr(1).split('&'), function (item) {
            var pair = item.split('=').map(function (part) {
                return decodeURIComponent(part.replace(/\+/g, '%20'));
            });
            if (pair[0])
                params[pair[0]] = pair[1];
        });

        return params;
    };
});

